import { render, staticRenderFns } from "./column-manager.vue?vue&type=template&id=3fa19cbe&"
import script from "./column-manager.vue?vue&type=script&lang=js&"
export * from "./column-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports